import {addSpareSlotsToQuotaGroups, getMinValAllowedForTotalSampleSize} from "../utils/quotaGroups";
import tasksState from "./tasks/state";
import tasksMutations from "./tasks/mutations";

export const state = () => (tasksState);

export const getters = {
  groups: state => state.groups,
  questionIdsAndTypes: state => {
    const groups = state.groups.map((group, groupIndex) => (
        group.core_questions.map((core) => ({
          id: core.id,
          type: core.type,
          options: core.options,
          body: `${core.body.replace(/<[^>]+>/g, '')}`,
          question: `Page ${groupIndex + 1} question ${core.order}`,
          answers: core.options.map(opt => opt.label),
          page: groupIndex + 1,
          groupLabel: `Page ${groupIndex + 1}`
        }))
    ));
    return [].concat.apply([], groups);
  },
  questionIds: state => state.questionIds,
  reminders: state => state.reminders,
  task: state => state.task,
  currentGroup: state => state.currentGroup,
  useBasicRichTextEditor: state => state.task.type ? state.task.type.slug === 'messaging' : false,
  isWhatsApp: state => state.task.type ? state.task.type.slug === 'messaging' : false,
  quotaGroups: (state) => {
    return addSpareSlotsToQuotaGroups(state);
  },
  minValAllowedForTotalSampleSize: (state) => {
    return getMinValAllowedForTotalSampleSize(state.task.quota);
  }
};

export const mutations = tasksMutations;

export const actions = {
  async fetchTask({store, commit }, payload) {
    const { data } = await this.$axios.get(`${payload.path}`);
    commit('SET_TASK', data);
  },

  async fetchReminders ({ store, commit }, payload) {
    const { data } = await this.$axios.get(`${payload.path}/reminders`);
    commit('SET_TASK_REMINDERS', data);
  },

};
